<script lang="ts">
import { session } from '../../lib/auth.svelte';
import { isPilotMode } from '../../lib/pilot';
import { tenantCtx } from '../../lib/tenant.svelte';
import { isDemoTenant } from '../../lib/hospital-preview.svelte';
import { dashboardPreview } from '../../lib/dashboard/preview.svelte';
import { resolveDashboardRole, type DashboardRole } from '../../lib/dashboard/resolve';
import DashboardRolePicker from './DashboardRolePicker.svelte';
import ClinicDashboard from './clinic/ClinicDashboard.svelte';
  import AdminDashboard from './roles/AdminDashboard.svelte';
  import EnfermeriaDashboard from './roles/EnfermeriaDashboard.svelte';
  import MedicoDashboard from './roles/MedicoDashboard.svelte';
  import RecepcionDashboard from './roles/RecepcionDashboard.svelte';
  import LaboratorioDashboard from './roles/LaboratorioDashboard.svelte';
  import CajaDashboard from './roles/CajaDashboard.svelte';
  import FarmaciaDashboard from './roles/FarmaciaDashboard.svelte';
  import ImagenologiaDashboard from './roles/ImagenologiaDashboard.svelte';
  import QuirofanoDashboard from './roles/QuirofanoDashboard.svelte';
  import FinanzasDashboard from './roles/FinanzasDashboard.svelte';
  import MspasDashboard from './roles/MspasDashboard.svelte';
  import AuditoriaDashboard from './roles/AuditoriaDashboard.svelte';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  /** Rol efectivo: preview manual (demo) o rol del usuario. */
  const rol = $derived(
    dashboardPreview.role ?? resolveDashboardRole(session.value?.roles),
  );

  const useClinicDashboard = $derived(tenantCtx.isClinicEdition);

  const showRolePicker = $derived(
    !useClinicDashboard
    && (isPilotMode()
    || isDemoTenant(session.value?.tenantId)
    || (session.value?.roles ?? []).some(r => r === 'admin-tenant' || r === 'admin-platform')),
  );
</script>

{#if useClinicDashboard}
  <ClinicDashboard {onNavigate} />
{:else}
  {#if showRolePicker}
    <DashboardRolePicker />
  {/if}

  {#key rol}
    {#if rol === 'admin'}
      <AdminDashboard {onNavigate} />
    {:else if rol === 'enfermeria'}
      <EnfermeriaDashboard {onNavigate} />
    {:else if rol === 'medico'}
      <MedicoDashboard {onNavigate} />
    {:else if rol === 'recepcion'}
      <RecepcionDashboard {onNavigate} />
    {:else if rol === 'laboratorio'}
      <LaboratorioDashboard {onNavigate} />
    {:else if rol === 'caja'}
      <CajaDashboard {onNavigate} />
    {:else if rol === 'farmacia'}
      <FarmaciaDashboard {onNavigate} />
    {:else if rol === 'imagenologia'}
      <ImagenologiaDashboard {onNavigate} />
    {:else if rol === 'quirofano'}
      <QuirofanoDashboard {onNavigate} />
    {:else if rol === 'finanzas'}
      <FinanzasDashboard {onNavigate} />
    {:else if rol === 'mspas'}
      <MspasDashboard {onNavigate} />
    {:else if rol === 'auditoria'}
      <AuditoriaDashboard {onNavigate} />
    {:else}
      <AdminDashboard {onNavigate} />
    {/if}
  {/key}
{/if}

<style>
  :global(.active-dash) { animation: fadeIn 0.22s ease-out; }
  @keyframes fadeIn {
    from { opacity: 0.35; transform: translateY(6px); }
    to { opacity: 1; transform: none; }
  }
</style>
